import { render, staticRenderFns } from "./category-page.vue?vue&type=template&id=78501966&"
import script from "./category-page.vue?vue&type=script&lang=ts&"
export * from "./category-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78501966')) {
      api.createRecord('78501966', component.options)
    } else {
      api.reload('78501966', component.options)
    }
    module.hot.accept("./category-page.vue?vue&type=template&id=78501966&", function () {
      api.rerender('78501966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/category-page/category-page.vue"
export default component.exports